const BellIcon = ({ color = '#155DFC', width = '20px', height = '20px' }) => {
	return (
		<svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M8.55664 17.5C8.70293 17.7533 8.91332 17.9637 9.16668 18.11C9.42003 18.2563 9.70743 18.3333 9.99997 18.3333C10.2925 18.3333 10.5799 18.2563 10.8333 18.11C11.0866 17.9637 11.297 17.7533 11.4433 17.5"
				stroke={color}
				strokeWidth="1.66667"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2.71772 12.773C2.60886 12.8923 2.53702 13.0407 2.51094 13.2001C2.48486 13.3595 2.50566 13.523 2.57081 13.6708C2.63597 13.8186 2.74267 13.9443 2.87794 14.0325C3.0132 14.1208 3.17121 14.1679 3.33272 14.168H16.6661C16.8276 14.168 16.9856 14.1212 17.1209 14.0331C17.2563 13.945 17.3631 13.8194 17.4285 13.6717C17.4938 13.524 17.5148 13.3605 17.4889 13.2011C17.4631 13.0417 17.3914 12.8933 17.2827 12.7738C16.1744 11.6313 14.9994 10.4171 14.9994 6.66797C14.9994 5.34189 14.4726 4.07012 13.5349 3.13243C12.5972 2.19475 11.3255 1.66797 9.99939 1.66797C8.67331 1.66797 7.40154 2.19475 6.46386 3.13243C5.52618 4.07012 4.99939 5.34189 4.99939 6.66797C4.99939 10.4171 3.82356 11.6313 2.71772 12.773Z"
				stroke={color}
				strokeWidth="1.66667"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default BellIcon;
